import {useUserInfoStore} from '@/stores/userInfoStore'
import { formatURIComponent } from './utils'


export default (instance:string) => {
    const userInfoStore = useUserInfoStore()
    const userInfo = userInfoStore.info as any
    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}`
    }


    const getPushUrl = () => {
        if (userInfo["project_push"] == "采购"){
            return makeUrl(`/内容文件/我的赋能链/在建待建/在建待建清单（采购）.json`)
        }else if (userInfo["project_push"] == "设计"){
            return makeUrl(`/内容文件/我的赋能链/在建待建/在建待建清单（设计）.json`)
        }else if (userInfo["project_push"] == "酒管"){
            return makeUrl(`/内容文件/我的赋能链/在建待建/在建待建清单（酒管）.json`)
        } else {
            return makeUrl(`/内容文件/我的赋能链/在建待建/404.pdf`)
        }
    }

    const getAnnualReportUrl = () => {
        if (userInfo["project_push"] == "采购"){
            return makeUrl(`/内容文件/我的赋能链/年报递送/酒店采购 2023.pdf`)
        }else if (userInfo["project_push"] == "设计"){
            return makeUrl(`/内容文件/我的赋能链/年报递送/酒店设计 2024.pdf`)
        }else if (userInfo["project_push"] == "酒管"){
            return makeUrl(`/内容文件/我的赋能链/年报递送/酒店管理集团 2024.pdf`)
        } else {
            return makeUrl(`/内容文件/我的赋能链/年报递送/404.pdf`)
        }
    }


    const userCompany = userInfo["user_company"]


    return [
        {
            pageLayout: 'tabs',
            pageTitlePrefix: '我的',
            pageTitle: '赋能链',
            pageTitleIcon: '/icons/华美云.svg',
            icons: [
                { 
                    name: '年报递送',
                    img: '/icons/年报递送.svg',
                    url: getAnnualReportUrl(),
                    path: "我的/年报递送"
                },
                { 
                    name: '公号推广',
                    img: '/icons/公号推广.svg',
                    url: makeUrl(`/内容文件/我的赋能链/公号推广/${userCompany}`),
                    path: "我的/公号推广"
                },
                { 
                    name: '公司介绍',
                    img: '/icons/公司介绍.svg',
                    url: makeUrl(`/内容文件/我的赋能链/公司介绍/${userCompany}`),
                    path: "我的/公司介绍"
                },
                {
                    name: '在建待建',
                    img: '/icons/趋势分析.svg',
                    background: 'black',
                    url: makeUrl('/内容文件/华美/在建待建'),
                    // url: makeUrl('/内容文件/华美/在建待建/在建待建.json'),
                    path: "华美顾问/在建待建"
                },
                {
                    name: '正在招标',
                    img: '/icons/趋势分析.svg',
                    background: 'black',
                    url: makeUrl('/内容文件/华美/正在招标'),
                    // url: makeUrl('/内容文件/华美/在建待建/在建待建.json'),
                    path: "华美顾问/正在招标"
                },
                { 
                    name: '培训课',
                    img: '/icons/业主培训.svg',
                    url: makeUrl(`/内容文件/我的赋能链/培训课/${userCompany}`),
                    path: "我的/培训课"
                },
                { 
                    name: '考察酒店',
                    img: '/icons/业主考察.svg',
                    url: makeUrl(`/内容文件/我的赋能链/考察酒店/${userCompany}`),
                    path: "我的/考察酒店"
                },
            ]
        },{
            pageLayout: 'tabs',
            pageTitlePrefix: '我的',
            pageTitle: '华美云',
            icons: [
            { 
                name: '关注酒店',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/favorite/hotel`),
                path: "我的"
            },
            { 
                name: '关注城市',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/favorite/city`),
                path: "我的"
            },
            { 
                name: '关注品牌',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/favorite/brand`),
                path: "我的"
            },
            { 
                name: '关注集团',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/favorite/group`),
                path: "我的"
            },
            { 
                name: '关注研报',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/favorite/file`),
                path: "我的"
            },
            { 
                name: '华美服务',
                img: '/icons/我的品牌.svg',
                url: makeUrl(`/内容文件/华美/华美简介`),
                path: "我的"
            },
            
        ]},
    ]
}